import React from "react";
import { Alert } from "reactstrap";
import { StickyButtonType } from "../../app/models/toolbar";
import OnairToggleButton from "../buttons/toolbar/OnairToggleButton";
import ShareButton from "../buttons/toolbar/ShareButton";

interface IParams {
  type: StickyButtonType;
}

export const ToolbarStickyButton: React.FC<IParams> = ({ type }) => {
  const renderButton = () => {
    switch (type) {
      case "share":
        return <ShareButton />;
      case "onair":
        return <OnairToggleButton />;
      default:
        return <Alert>{type} button not implemented</Alert>;
    }
  };

  return (
    <>
      {type !== "empty" && (
        <div className="d-inline-block divShareButton">
          <div className="verticalDivider ml-auto toolbarHeight position-absolute"></div>
          <div className=" mr-0 divButton ml-2">{renderButton()}</div>
        </div>
      )}
    </>
  );
};
